import React, { FC } from 'react';
import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LinearProgressBarWithLabelProps = {
    progress: number;
};
const LinearProgressBarWithLabel: FC<LinearProgressBarWithLabelProps> = ({
    progress,
}: LinearProgressBarWithLabelProps) => {
    return <LinearProgressWithLabel value={progress} />;
};

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    const { t: translate } = useTranslation(['common']);
    return (
        <Box>
            <Box>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ textAlign: 'center' }} mt={1}>
                <Typography variant="subtitle2">
                    {props.value < 100
                        ? `${translate('common:UPLOADING')}(${Math.round(props.value)}%)`
                        : `${translate('common:PROCESSING')}`}
                </Typography>
            </Box>
        </Box>
    );
}

export default LinearProgressBarWithLabel;
